import moment from 'moment'

const validateInputTime = (attr, value) => {
  const attributeInputNameTime = ["budget.operatingTime.from",
                                  "budget.operatingTime.to"  ,
                                  "actual.operatingTime.from",
                                  "actual.operatingTime.to"  ,];
  return ((attributeInputNameTime.includes(attr) && value && moment.isMoment(value)));
}
const generateCo2InputObject = (index, attr, value) => {
  const rootAttribute = "co2InSiteWork";
  const path = [rootAttribute, index, attr].join(".");
  const objectInput = { path: path, value: value };
  return objectInput;
}
const validateMachineLayer = (attr) => {
  const attributeNameThreeLayer = ["oldMachineFirstLayer", "oldMachineSecondLayer", "oldMachineThirdLayer"];
  return attributeNameThreeLayer.includes(attr);
}
const validateDifferentActualTime = (actual_dt, unit) => {
  return !(actual_dt.from == null     ||
          actual_dt.to == null        ||
          actual_dt.from == undefined ||
          actual_dt.to == undefined   ||
          unit == ""                  ||
          unit == undefined           ||
          actual_dt.from == actual_dt.to)
}
export default {
  validateInputTime,
  generateCo2InputObject,
  validateMachineLayer,
  validateDifferentActualTime,
};